<template>
    <kgr-searchable-dropdown
        display="extendedName"
        :label="label"
        :options="filteredTeams"
        :loading="loading"
        @post-input="onInput"
    />
</template>

<script>
import Department from '../../../../js/dto/Department';
import DepartmentRepository from '../../../../js/repository/DepartmentRepository';
import SearchableDropdown from './SearchableDropdown.vue';
import Team from '../../../../js/dto/Team';
import TeamRepository from '../../../../js/repository/TeamRepository';

export default {
    components: {
        'kgr-searchable-dropdown': SearchableDropdown,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        value: {
            type: Team,
            required: false,
            default: () => {
                return null;
            },
        },
        department: {
            type: Department,
            required: false,
            default: () => {
                return null;
            },
        },
        excludedIds: {
            type: Array,
            required: false,
            default: () => {
                return [];
            },
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loading: true,
            teams: [],
        };
    },
    computed: {
        label() {
            return this.hideLabel ? null : this.$t('team');
        },
        filteredTeams() {
            return this.teams.filter((team) => this.excludedIds.indexOf(team.id) === -1);
        },
    },
    watch: {
        department(newVal) {
            if (newVal) {
                this.loading = true;
                DepartmentRepository.findTeams(newVal.id)
                    .then((teams) => {
                        this.teams = teams;
                    })
                    .catch(() => this.$notify.error('error.loadingData'))
                    .finally(() => this.loading = false);
            }
        },
    },
    created() {
        TeamRepository
            .findAll(this.clubId)
            .then((data) => {
                this.teams = data;
                this.loading = false;
            })
            .catch(() => this.$notify.error('error.loadingData'));
    },

    methods: {
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
    },
};
</script>
